import { render } from "./about-team.vue?vue&type=template&id=f8d13ce6"
import script from "./about-team.vue?vue&type=script&lang=js"
export * from "./about-team.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__